import React, { useEffect, useRef } from "react";
import { useAuth } from "../auth";

const AuthButton: React.FC = () => {
  const { ready, isLoggedIn, clientId, signOut } = useAuth();
  const btnRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!ready || isLoggedIn) return;
    if (!clientId) return; // no auth configured
    const el = btnRef.current;
    if (!el) return;
    try {
      // Render Google provided button for a11y and brand consistency
      (window as any).google?.accounts.id.renderButton(el, {
        type: "standard",
        theme: "outline",
        size: "medium",
        text: "signin_with",
        shape: "rectangular",
        logo_alignment: "left",
      });
    } catch {}
  }, [ready, isLoggedIn, clientId]);

  if (!clientId) {
    // No client configured; keep UI tidy
    return null;
  }

  if (!isLoggedIn) {
    return <div ref={btnRef} aria-label="Sign in with Google" />;
  }

  // We've moved the detailed user display to UserAccountDisplay component
  // Just show a simple sign out button in the header
  return (
    <>
      <button onClick={signOut} className="header-signout-btn">
        Sign out
      </button>

      <style>{`
        .header-signout-btn {
          border: 3px solid #000;
          box-shadow: 3px 3px 0 #000;
          background: #fff;
          padding: 6px 10px;
          font-weight: 800;
          cursor: pointer;
          transition: transform 80ms ease-out, box-shadow 80ms ease-out;
        }
        
        .header-signout-btn:hover {
          transform: translate(-2px, -2px);
          box-shadow: 5px 5px 0 #000;
        }
      `}</style>
    </>
  );
};

export default AuthButton;
